import Vue from 'vue'
import vueI18n from 'vue-i18n'
Vue.use(vueI18n);
import zh from './config/zh';
import en from './config/en';

import Element from 'element-ui'

const messages = {
    en,
    zh,
};
const language = (navigator.language || 'zh').toLocaleLowerCase(); // 这是获取浏览器的语言
const i18n = new vueI18n({
    legacy: false, // 必须设置，否则报错
    locale: localStorage.getItem('lang') || language.split('-')[0] || 'zh', // 首先从缓存里拿，没有的话就用浏览器语言，
    fallbackLocale: 'zh', // 设置备用语言
    messages,
});

// 切换element内部组件的中英文
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})

export default i18n;



// WEBPACK FOOTER //
// ./src/utils/i18n/index.js